import PageInfo from "./components/PageInfo";
import { PageInfoProps } from "./components/PageInfo/const";
import styles from "./index-pc.module.scss";

export default (pageInfoProps: PageInfoProps) =>
  PageInfo(pageInfoProps, styles);
